import { Component, OnInit } from '@angular/core';
import { NeproseService } from 'src/app/services/neprose.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-trending-properties',
  templateUrl: './trending-properties.component.html',
  styleUrls: ['./trending-properties.component.css']
})
export class TrendingPropertiesComponent implements OnInit {

  propertyList = []

  municipalityList = []

  loaded: boolean

  constructor( private neproseService: NeproseService, private route: ActivatedRoute ) {}

  ngOnInit(): void {
    this.route.data.subscribe((data: { municipalityList: any})=> {
      this.municipalityList = data.municipalityList.municipalities
    })

    this.neproseService.getTrendingProperties().subscribe(data => {
      this.loaded = true
      if(data.status){
        let properties = []
        let propertyList = data.propertyAds
        if(propertyList.length > 4){
          propertyList = propertyList.splice(0, 4)
        }
        for(let property of propertyList){
          if(property.status == 'completed'){
            property['featuredImage'] = environment.url+'/assets/placeholder-image.png'
          if(property.PropertyImage){
            let propertyImages = JSON.parse(property.PropertyImage.imagePath)
              if(propertyImages.length > 0){
                property.featuredImage = environment.api+'/images/'+propertyImages[0]
              }
            }
            let municipality = this.municipalityList.find(municipality => municipality.id == property.municipality_id)
            let address = municipality.municipality
            if(property.village){
              address = property.village+', '+address
            }
            property['address'] = address
            
            //Nepali Style comma separated number for price
            let lastThree = property.price.toString().substring(property.price.toString().length-3);
            let otherNumbers = property.price.toString().substring(0,property.price.toString().length-3);
            if(otherNumbers != '')
                lastThree = ',' + lastThree;
            property['price'] = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
            //End
            
            properties.push(property)
          }
        }
        this.propertyList = properties
      }
    }, error => {
      this.loaded = true
    })
  }

}
